// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__26nZ7","notes":"Notes_notes__3F025"};